import {
  IneligibleReasonGeneral,
  LanguageEvaluationResult,
  OutgoingChannelEvaluationResult,
} from 'lib-shared-types-api';

/** Messages for channel-level evaluation results */
export const CHANNEL_MESSAGES: Record<
  OutgoingChannelEvaluationResult['kind'],
  string
> = {
  EligibleOutgoingChannel: 'Filter triggered',
  EndUserDoesNotHaveContactPointOfKindNeededByChannel:
    'Customer missing the needed contact point',
  SurveyDoesNotExist: 'Survey not found',
};

/** Messages for language-level evaluation results */
export const LANGUAGE_MESSAGES: Record<
  LanguageEvaluationResult['kind'],
  string
> = {
  MatchOnRatingLanguage: 'Survey language matched the rating language',
  MatchOnDefaultLanguage: 'Survey language matched default language (EN)',
  NoMatch: 'No survey language matched the needed language',
  Disabled: 'The needed survey language is disabled',
};

/** Messages for general ineligible reasons at conversation level */
export const GENERAL_INELIGIBLE_MESSAGES: Record<
  IneligibleReasonGeneral,
  string
> = {
  UserIsUnsubscribed: 'Customer has unsubscribed from surveys',
  InvalidMsgCombination: 'Invalid message combination',
  SideConversation: 'Side conversation not eligible',
  ImportedConversation: 'Imported conversation not eligible',
  UnansweredOutboundVoiceCall: 'Unanswered outbound voice call',
  NoOutboundMessageToConversationRequester:
    'No outbound message was addressed to the conversation requester',
};
